import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { withTheme } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { brand } from 'theme';

const gradientAnimation = keyframes`
  0%{background-position:100% 0%}
  50%{background-position:0% 100%}
  100%{background-position:100% 0%}
`;

const backgroundImage = (props, width) =>
  css`
    background-image: ${props =>
      props.backgroundimg
        ? `url('${props.backgroundimg}?format=pjpg&width=${width}&quality=50&auto=webp')`
        : 'none'};
  `;

const SectionWrapper = withTheme()(styled.div`
  background: ${props => props.backgroundcolor || 'white'};
  position:relative;
${props =>
  props.animatedBackground &&
  css`
    background: linear-gradient(props?.theme?.brand?.gradient?.primary);
    background-size: 400% 400%;
    animation: ${gradientAnimation} 15s linear infinite;
  `}

  ${props =>
    props.fullHeight &&
    css`
      margin-top: -10vh;
      margin-bottom: -10vh;
      padding-top: -10vh;
      padding-bottom: -10vh;
    `} ${props =>
  props.backgroundimg &&
  css`
    position: relative;

    &:after {
      content: '';
      background-size: ${props => (props.backgroundimg ? 'cover' : 'none')};
      background-position: 50% 50%;
      opacity: ${props => props.backgroundopacity || '.25'};
      mix-blend-mode: ${props => (props.noBlend ? 'initial' : 'luminosity')};
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      position: absolute;
      z-index: 0;
      ${backgroundImage(props, 320)}
      @media (min-width: 780px) {
        ${backgroundImage(props, 780)}
      }
      @media (min-width: 1200px) {
        ${backgroundImage(props, 1200)}
      }
    }

    * {
      z-index: 1;
    }
  `};
`);

const SectionGrid = styled(Grid)`
  padding-top: ${props => (props.size === 'small' ? '5vh' : '15vh')};
  padding-bottom: ${props => (props.size === 'small' ? '5vh' : '15vh')};
`;

const SectionHeader = styled(
  ({ noGutter, bottomGutter, topGutter, ...other }) => <Typography {...other} />
)`
  margin-bottom: ${props =>
    props.noGutter || props.bottomGutter ? '0' : '2vh'};
  padding-bottom: ${props => (props.noGutter || props.topGutter ? '0' : '2vh')};

  display: inline-block;

  &:after {
    margin-top: 2vh;
    display: block;
    content: '';
    height: 4px;
    background: linear-gradient(${brand.main.gradient.primary});
    width: 100%;
  }
`;

const SectionDivider = styled(Divider)`
  margin-top: 5vh;
  margin-bottom: 5vh;
`;

export { SectionWrapper, SectionGrid, SectionHeader, SectionDivider };
